const Spinner = (
  props: { sizeRem?: number; color?: string } = { sizeRem: 2 },
) => {
  const { sizeRem, color } = props
  return (
    <div className="text-center">
      <div
        className="spinner-border"
        role="status"
        style={{
          width: `${sizeRem}rem`,
          height: `${sizeRem}rem`,
          color,
        }}>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default Spinner
